import React, { useState, useCallback } from 'react';
import { ButtonLanding } from './buttonLanding';
import { useWidth } from 'utils';
import { MyCalendlyComponent } from '../../pages/landing/contactUs/fragments/myCalendlyComponent';
import { CloseButton } from './closeButton';
import { Backdrop } from '@mui/material';
import Modal from '@mui/material/Modal';

/**
 * RequestDemoButton — owns its own modal + a single persistent MyCalendlyComponent.
 *
 * The Calendly iframe is mounted once on first open and kept alive in the DOM
 * (hidden via CSS) so subsequent open/close cycles are instant.
 */
export const RequestDemoButton = ({ calendlyWidth = '55vw', text = 'Request a Demo', ...rest }) => {
    const width = useWidth();
    const [open, setOpen] = useState(false);
    const [mounted, setMounted] = useState(false); // mount once, never unmount

    const handleOpen = useCallback(() => {
        setMounted(true); // first click mounts the iframe; subsequent clicks are no-ops
        setOpen(true);
    }, []);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const calendlyStyles = {
        width: width > 1000 ? '1000px' : '100%',
        height: width > 1000 ? '700px' : '70vh',
    };

    const bodyPadding = width > 1000 ? 0 : '12px';

    return (
        <>
            <ButtonLanding text={text} onClick={handleOpen} {...rest} />

            {/* Render the MUI Modal with keepMounted so the iframe survives close */}
            <Modal
                disableScrollLock={true}
                open={open}
                aria-labelledby="calendly-modal"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                    onClick: handleClose,
                }}
                keepMounted
            >
                {/* Outer div mirrors CustomModal's body wrapper (line 65 of modalBase.js) */}
                <div>
                    <div
                        style={{ outline: 'none' }}
                        className="modal-wrapper-style open-sans"
                    >
                        <div className="modal-header-style">
                            <CloseButton handleCLic={handleClose} />
                        </div>
                        <div className="modal-body-style" style={{ padding: bodyPadding }}>
                            {mounted && <MyCalendlyComponent styles={calendlyStyles} />}
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
